/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Player_Or_SeparatorInputs */



/**
* | output |
* | --- |
* | "— or —" |
*
* @param {Add_Player_Or_SeparatorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const add_player_or_separator = /** @type {((inputs?: Add_Player_Or_SeparatorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Player_Or_SeparatorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("— ou —")
	if (locale === "es") return /** @type {LocalizedString} */ ("— o —")
	if (locale === "pt") return /** @type {LocalizedString} */ ("— ou —")
	if (locale === "it") return /** @type {LocalizedString} */ ("— oppure —")
	return /** @type {LocalizedString} */ ("— or —")
});